// extracted by mini-css-extract-plugin
module.exports = {"next-sr-only":"ServiceTicketsTable--next-sr-only--d8WiYME","formTitle":"ServiceTicketsTable--formTitle--3BDgLxR","submitButton":"ServiceTicketsTable--submitButton--3UXvYFI"};